import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChairIcon from "@mui/icons-material/Chair";

const API = process.env.REACT_APP_API_URL;

const LibrarySeatManager = ({ open, onClose, onSuccess }) => {
  const [seatNumber, setSeatNumber] = useState("");

  const createSeat = async () => {
    if (!seatNumber.trim()) {
      toast.error("Enter seat number");
      return;
    }
    const loadingToast = toast.loading("Loading...");

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}library/seats/`,
        { seat_number: seatNumber },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.dismiss(loadingToast);

      toast.success("Seat created successfully!");
      setSeatNumber("");
      onSuccess?.();
      onClose?.();
    } catch (err) {
      toast.dismiss(loadingToast);
      if (err.response?.data) {
        const errorData = err.response.data;

        const seatError = errorData?.seat_number?.[0]?.toLowerCase();
        if (
          seatError &&
          (seatError.includes("already exists") || seatError.includes("seat"))
        ) {
          toast.error("Seat number already exists!");
          return;
        }

        const firstField = Object.keys(errorData)[0];
        toast.error(errorData[firstField]?.[0] || "Failed to create seat");
      } else {
        toast.error("Failed to create seat");
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="flex justify-between items-center">
        <span className="flex items-center gap-2 text-xl font-semibold text-primaryText">
          <ChairIcon className="text-primaryColor" />
          Add Library Seat
        </span>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className="space-y-4">
        <TextField
          label="Seat Number"
          fullWidth
          variant="outlined"
          value={seatNumber}
          onChange={(e) => setSeatNumber(e.target.value)}
        />
      </DialogContent>

      <DialogActions className="px-6 pb-4">
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={createSeat} variant="contained" color="primary">
          + Create Seat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LibrarySeatManager;
